import React, { useMemo } from 'react';
import { Layer, Line, Text } from 'react-konva';

function FloorPlanGrid({ width, height, gridSize, zoom, viewport, unit, visible }) {
  const lines = useMemo(() => {
    if (!visible) return { horizontal: [], vertical: [], labels: [] };

    const scaledGrid = gridSize * zoom;
    // Don't render grid if too small or too large
    if (scaledGrid < 5 || scaledGrid > 500) return { horizontal: [], vertical: [], labels: [] };

    const startX = Math.floor(-viewport.x / scaledGrid) * scaledGrid;
    const startY = Math.floor(-viewport.y / scaledGrid) * scaledGrid;
    const endX = startX + width + scaledGrid * 2;
    const endY = startY + height + scaledGrid * 2;

    const horizontal = [];
    const vertical = [];
    const labels = [];
    const majorEvery = unit === 'imperial' ? 12 : 10; // every foot or every 10cm

    for (let x = startX; x <= endX; x += scaledGrid) {
      const worldX = (x - viewport.x) / zoom;
      const isMajor = Math.abs(Math.round(worldX / gridSize) % (majorEvery / gridSize)) < 0.01;
      vertical.push({
        points: [x + viewport.x, 0, x + viewport.x, height],
        stroke: isMajor ? 'rgba(150,150,150,0.35)' : 'rgba(200,200,200,0.2)',
        strokeWidth: isMajor ? 1 : 0.5,
      });
    }

    for (let y = startY; y <= endY; y += scaledGrid) {
      const worldY = (y - viewport.y) / zoom;
      const isMajor = Math.abs(Math.round(worldY / gridSize) % (majorEvery / gridSize)) < 0.01;
      horizontal.push({
        points: [0, y + viewport.y, width, y + viewport.y],
        stroke: isMajor ? 'rgba(150,150,150,0.35)' : 'rgba(200,200,200,0.2)',
        strokeWidth: isMajor ? 1 : 0.5,
      });
    }

    return { horizontal, vertical, labels };
  }, [width, height, gridSize, zoom, viewport, visible, unit]);

  if (!visible) return null;

  return (
    <Layer listening={false}>
      {lines.vertical.map((line, i) => (
        <Line key={`v${i}`} {...line} />
      ))}
      {lines.horizontal.map((line, i) => (
        <Line key={`h${i}`} {...line} />
      ))}
      {lines.labels.map((label, i) => (
        <Text key={`l${i}`} {...label} />
      ))}
    </Layer>
  );
}

export default React.memo(FloorPlanGrid);
